import React from 'react'
import {MdClose} from 'react-icons/md';
import styled from 'styled-components';
import {
  Container,
  Row,
  Col
} from 'reactstrap';


const ModalContainer = props => {
  return (
    <Overlay>
      <ModalWrapper>
      <Container>
        <Row>
          <Col lg={3} />
          <Col lg={6}>
            <Modal>
              {props.children}
              <CloseModal onClick={props.close}/>
            </Modal>
          </Col>
          <Col lg={3} />
        </Row>
      </Container>
      </ModalWrapper>
      
    </Overlay>
  );
};

const Overlay = styled.div`
  position: fixed;
  background: rgba(0,0,0,0.5);
  top: 0px;
  bottom: 0px;
  left: 0px;
  right: 0px;
  padding-top: 40px;
  z-index: 5000;
`;

const ModalWrapper = styled.div`
  position: absolute;
  width: 100%;
  top: 50%;
  left: 50%;
  transform: translate(-50%,-50%);
`;

const Modal = styled.div`
  border-radius: 8px;
  padding: 20px;
  background: #fff;
  box-shadow: 0px 5px 20px 0px rgba(0,0,0,0.3);
  overflow: auto;
  position: relative;
`;

const CloseModal = styled(MdClose)`
  position: absolute;
  top: 10px;
  right: 10px;
  cursor: pointer;
`;

export default ModalContainer;
